<template>
    <div class="head_box">
        <div v-for="item,index in tabList" :key="index">
            <router-link class="head_cen" :style="tabState == index?'color: #00B1AE;':''" :to="item.to">
                <img class="head_img" :src="tabState == index? item.image1:item.image2" alt="">
                {{ item.name }}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "TabbarIndex",
    props: ['tabState'],
    data() {
        return {
            tabList: [{
				name:'首页',
                image1: require('@/assets/tab/icon1.png'),
                image2: require('@/assets/tab/icon2.png'),
				to:{
					path:'/'
				}
			},{
				name:'心理测评',
                image1: require('@/assets/tab/icon3.png'),
                image2: require('@/assets/tab/icon4.png'),
				to:{
					path:'/appraisal'
				}
			},{
				name:'咨询师预约',
                image1: require('@/assets/tab/icon5.png'),
                image2: require('@/assets/tab/icon6.png'),
				to:{
					path:'/subscribe'
				}
			},{
				name:'文章阅读',
                image1: require('@/assets/tab/icon7.png'),
                image2: require('@/assets/tab/icon8.png'),
				to:{
					path:'/essay'
				}
			},{
				name:'我的',
                image1: require('@/assets/tab/icon9.png'),
                image2: require('@/assets/tab/icon10.png'),
				to:{
					path: localStorage.getItem('accountType') == 1 ? '/my' : 'counselor'
				}
			}],
        };
    },
    mounted() {},
    methods: {}
};
</script>

<style scoped lang="less">
.head_box {
    width: calc(100% - 20px);
    height: 59px;
    padding: 0 10px 15px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    border-top: 1px solid #f2f2f2;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99;

    .head_cen {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #6F737A;
        margin: 0 10px;

        .head_img {
            width: 32px;
            object-fit: contain;
        }
    }
}
</style>